<template>
<div class="quizier-module module-quote">
    <div class="wfit quote-cont animate__animated animate__zoomIn faster" data-wow-delay="0.2s" :style="[quote_image? { backgroundImage: `url('${quote_image}')` } : '']">
        <div class="quote" data-wow-delay="0.3s" :style="[bg_color? { 'background-color': bg_color } : '']">
            <div class="wfit img-cont animate__animated animate__zoomInUp fast" data-wow-delay="0.4s" v-if="author_image && quote_layout == 'thumb'">
                <div class="author_img" :style="[author_image? { backgroundImage: `url('${author_image}')` } : '']"></div>
            </div>
            <div class="quote-txt-cont wfit animate__animated animate__zoomInLeft fast" :class="[{'has_border' : has_border, 'has_quote_icon' : has_quote_icon}, quote_class]" data-wow-delay="0.5s">
                <div class="txt"><span class="quote-icon" v-html="svg('quote-left')" v-if="has_quote_icon"></span> {{ quote_text }} </div>
                <div class="wfit quote-author animate__animated animate__zoomInRight fast" data-wow-delay="0.7s">{{ quote_author }} <span v-if="quote_title">, {{ quote_title }}</span></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import mixinComponent from '../mixins';

export default {
    props: [],
    mixins: [mixinComponent],
    data() {
        return {
            colors_alpha: 'rgba(0,0,0,0.7)',
            colors: 'rgba(0,0,0,1)',
            layout: 'default',
            text_class: 'text-color-light',
            border: true,
            quote_icon: true
        }
    },
    computed: {
        bg_color: function () {
            const image = this.has('media_path', false);
            const alpha = image ? 0.7 : 1;
            const color = image ? this.colors_alpha : this.colors;
            return this.rgbaToString('colors.rgba', color, alpha);
        },
        has_border: function () {
            return this.has('border', this.border);
        },
        has_quote_icon: function () {
            return this.has('quote_icon', this.quote_icon);
        },
        quote_text: function () {
            return this.has('quote_text');
        },
        quote_author: function () {
            return this.has('author');
        },
        quote_title: function () {
            return this.has('author_title');
        },
        quote_layout: function () {
            return this.has('layout', this.layout);
        },
        quote_class: function () {
            return this.has('text_class', this.text_class);
        },
        quote_image: function () {
            return this.has('media_path', false);
        },
        author_image: function () {
            return this.has('author_media_path', false);
        }
    }
}
</script>
